import { LegalInfo } from "../domain/legalInfo.entity";
import { regenPropertyCache } from "../../common/api";

export function useLegalInfoApiHandlers(httpClient: any, propertyTicker: string) {
  const onGetAll = async () => {
    return await httpClient.get(`/api/legal/${propertyTicker}/legalInfo`);
  };

  const onGetOne = async (id: number) => {
    return await httpClient.get(`/api/legal/${propertyTicker}/legalInfo/${id}`);
  };

  const onCreate = async (entity: LegalInfo): Promise<number> => {
    try {
      const toSend: Partial<LegalInfo> = { ...entity };
      if (toSend.id === -1) {
        toSend.id = undefined;
      }
      const response = await httpClient.post(`/api/legal/legalInfo`, toSend);

      await regenPropertyCache(httpClient, propertyTicker);

      return response.id;
    } catch (error) {
      throw error;
    }
  };

  const onUpdate = async (entity: LegalInfo): Promise<void> => {
    try {
      await httpClient.put("/api/legal/legalInfo", entity);

      await regenPropertyCache(httpClient, propertyTicker);
    } catch (error) {
      throw error;
    }
  };

  const onDelete = async (id: number) => {
    try {
      await httpClient.delete(`/api/legal/${propertyTicker}/legalInfo/${id}`);

      await regenPropertyCache(httpClient, propertyTicker);
    } catch (error) {
      throw error;
    }
  };

  return { onGetAll, onGetOne, onCreate, onUpdate, onDelete };
}
